import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CATEGORIES } from "./constants.js";

export const getSubcategoryDetails = (key) => {
	const keys = key.replaceAll("-", "_").split(".");
	return CATEGORIES[keys[0]][keys[1]];
};

export const roundNearest100 = (num) => {
	return Math.round(num / 100) * 100;
};

export const getSubcategoryFromPath = (path) => {
	const chunks = path.split("/");
	return `${chunks[1]}.${chunks[2]}`;
};

export const pathToTranslation = (path, fullPath = true) => {
	//if false, without product
	let newPath = path.replaceAll("-", "_").substring(1);
	const keys = newPath.split("/");

	if (!fullPath && keys.length > 2) {
		keys.pop();
	}

	return keys.join(".");
};

export const addDataIntoCache = (cacheName, url, response) => {
	// Converting our response into Actual Response form
	const data = new Response(JSON.stringify(response));

	if ("caches" in window) {
		caches.open(cacheName).then((cache) => {
			cache.put(url, data);
		});
	}
};

export const getSingleCacheData = async (cacheName, url) => {
	try {
		if (typeof caches === "undefined") return false;

		const cacheStorage = await caches.open(cacheName);
		const cachedResponse = await cacheStorage.match(url);

		return cachedResponse.json().then((item) => {
			return item;
		});
	} catch (e) {
		return;
	}
};

export const usePreviousURL = () => {
	const [previousURL, setPreviousURL] = useState("");
	const location = useLocation();

	useEffect(() => {
		setPreviousURL(location.pathname);
	}, [location]);

	return previousURL;
};

export const useShouldScrollTop = () => {
	const previousURL = usePreviousURL();
	const currentURL = useLocation().pathname;

	useEffect(() => {
		const splittedPrevURL = previousURL?.split("/");
		const splittedCurrURL = currentURL?.split("/");

		const prevSplitIndex =
			splittedPrevURL.length === 3
				? splittedPrevURL.length - 1
				: splittedPrevURL.length - 2;

		const currSplitIndex =
			splittedCurrURL.length === 3
				? splittedCurrURL.length - 1
				: splittedCurrURL.length - 2;

		if (
			currentURL &&
			splittedPrevURL?.[prevSplitIndex] !== splittedCurrURL?.[currSplitIndex]
		) {
			window.scrollTo({ top: 0, behavior: "instant" });
		}
	}, [currentURL]);
};

const importAll = (r) => {
	if (Array.isArray(r)) {
		return r.flatMap((i) => i.keys().map(i));
	}
	return r.keys().map(r);
};

// Utility: pick `count` random images from all CATEGORIES in a group
export const getRandomImagesFromGroup = (gallery, count = 4) => {
	const importedGallery = importAll(gallery);
	const unique = Array.from(new Set(importedGallery));
	unique.sort(() => Math.random() - 0.5);

	const selected = unique.slice(0, count);
	while (selected.length < count && gallery.length) {
		selected.push(gallery[Math.floor(Math.random() * gallery.length)]);
	}
	return selected;
};
